import { createRoot } from 'react-dom/client'
import { onError, reportWebVitals } from '@praxis/component-logging'
import { OpenTelemetryManager } from '@measurement/opentelemetry-web'
import App from './App'

import { OTEL_PRD_API_KEY } from './config'

const otelConfig = {
  apiKey: OTEL_PRD_API_KEY,
  serviceName: 'veitembulk',
}

OpenTelemetryManager.initialize(otelConfig)

// Standard errors will be automatically logged to STDOUT when thrown.
// The logging sidecar in TAP will process and send logs to the appropriate environment in Kibana.
// Learn more about TAP sidecars: https://tapdocs.prod.target.com/runtime/sidecars/#_platform_sidecars
window.onerror = onError

// If you want to start measuring performance in your app, enable the reportWebVitals()
// function below. Learn more: https://praxis.prod.target.com/components/logging#quick-start-metrics
reportWebVitals()

const container = document.getElementById('root')
const root = createRoot(container)
root.render(<App />)
